<nb-card [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="giant">
  <app-datatable
    [columns]="columns"
    [rows]="championTv"
    [searchable]="searchable"
    [isSingleSelectView]="true"
    [searchControlSettings]="searchControlSettings"
    [minHeight]="minHeight"
    (filterChange)="onFilterChange($event)"
  >
  </app-datatable>
</nb-card>
